__turbopack_context__.v({
  "blue": "RightActionBanner-module-scss-module__I0HUwG__blue",
  "border_gray": "RightActionBanner-module-scss-module__I0HUwG__border_gray",
  "cornflower": "RightActionBanner-module-scss-module__I0HUwG__cornflower",
  "cyan": "RightActionBanner-module-scss-module__I0HUwG__cyan",
  "description": "RightActionBanner-module-scss-module__I0HUwG__description",
  "gray": "RightActionBanner-module-scss-module__I0HUwG__gray",
  "gray_sub_text_color": "RightActionBanner-module-scss-module__I0HUwG__gray_sub_text_color",
  "green": "RightActionBanner-module-scss-module__I0HUwG__green",
  "illust_icon": "RightActionBanner-module-scss-module__I0HUwG__illust_icon",
  "left": "RightActionBanner-module-scss-module__I0HUwG__left",
  "magenta": "RightActionBanner-module-scss-module__I0HUwG__magenta",
  "olive": "RightActionBanner-module-scss-module__I0HUwG__olive",
  "orange": "RightActionBanner-module-scss-module__I0HUwG__orange",
  "pink": "RightActionBanner-module-scss-module__I0HUwG__pink",
  "red": "RightActionBanner-module-scss-module__I0HUwG__red",
  "right": "RightActionBanner-module-scss-module__I0HUwG__right",
  "sub_text": "RightActionBanner-module-scss-module__I0HUwG__sub_text",
  "title": "RightActionBanner-module-scss-module__I0HUwG__title",
  "violet": "RightActionBanner-module-scss-module__I0HUwG__violet",
  "white": "RightActionBanner-module-scss-module__I0HUwG__white",
  "wrap": "RightActionBanner-module-scss-module__I0HUwG__wrap",
  "yellow": "RightActionBanner-module-scss-module__I0HUwG__yellow",
});
